import { OrderItemOptionFragment } from "./order-item-option";
import { OrderItemOriginalPriceAddonsFragment } from "./original-price-addons";
import { OrderItemSubtotalAddonsFragment } from "./subtotal-addons";

export const OrderItemFragment = /* GraphQL */ `
	fragment OrderItemFragment on OrderItem {
		_id
		created_at
		updated_at
		category
		item
		item_id
		is_master
		master_parent
		cost
		title
		original_price
		minimum_required_price
		original_price_addons {
			...OrderItemOriginalPriceAddonsFragment
		}
		unit_price
		listed_price
		quantity
		extra_quantity
		serving_quantity
		comments
		cancelled_reason
		recipe {
			raw_material
			unit_of_measurement
			consumed_unit_of_measurement
			consumed_quantity
		}
		options {
			...OrderItemOptionFragment
		}
		type
		course_index
		delivered_count
		status
		prep_time
		printer_tag
		subtotal
		subtotal_addons {
			...OrderItemSubtotalAddonsFragment
		}
		net_amount
		gross_amount
		cancelled_amount
		non_sales_credit_amount
		no_vat
		no_service_charge
		is_open_item
		is_hide_from_receipt
		is_paid
	}
	${OrderItemOptionFragment}
	${OrderItemOriginalPriceAddonsFragment}
	${OrderItemSubtotalAddonsFragment}
`;
